import React from 'react';
import PropTypes from 'prop-types';
import { AccessibleContent } from '@instructure/ui-a11y-content';
import t from 'format-message';
export default function AlignmentCount(_ref) {
  var count = _ref.count;
  if (count != null) {
    var title = t("{\n      count, plural,\n            =0 {No outcomes are aligned}\n          one {One outcome is aligned}\n        other {# outcomes are aligned}\n    }", {
      count: count
    });
    return /*#__PURE__*/React.createElement(AccessibleContent, {
      alt: title
    }, /*#__PURE__*/React.createElement("span", {
      title: title
    }, t("{\n            count, plural,\n                  =0 {(0)}\n                one {(1)}\n              other {(#)}\n          }", {
      count: count
    })
    // eslint-disable-next-line react/jsx-closing-tag-location
    ));
  }
  return /*#__PURE__*/React.createElement("span", null);
}
AlignmentCount.propTypes = {
  count: PropTypes.number
};
AlignmentCount.defaultProps = {
  count: null
};